import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Color from 'color';

const RibbonTagComponent = ({
  hideOnHover,
  height,
  ribbonTagColor,
  fullSizeTile,
  ribbonTagName,
}) => {
  const [hide, setHide] = useState(false);
  return (
    <RibbonTag
      id="ribbon-tag"
      onClick={() => setHide(true)}
      hideOnHover={hideOnHover}
      height={height}
      ribbonTagColor={ribbonTagColor}
      fullSizeTile={fullSizeTile}
      hide={hide}
    >
      <RibbonText ribbonTagColor={ribbonTagColor} fullSizeTile={fullSizeTile}>
        {ribbonTagName}
      </RibbonText>
      <RibbonTagArrow
        ribbonTagColor={ribbonTagColor}
        height={height}
        position="top"
      />
      <RibbonTagArrow
        ribbonTagColor={ribbonTagColor}
        height={height}
        position="bottom"
      />
    </RibbonTag>
  );
};

RibbonTagComponent.propTypes = {
  height: PropTypes.string.isRequired,
  ribbonTagName: PropTypes.string.isRequired,
  ribbonTagColor: PropTypes.string.isRequired,
  hideRibbonTag: PropTypes.string,
  hideOnHover: PropTypes.bool,
  fullSizeTile: PropTypes.bool,
  bottom: PropTypes.string,
};

export default RibbonTagComponent;

const RibbonTag = styled.div`
  background-color: ${({ ribbonTagColor }) => ribbonTagColor};
  height: ${({ height }) => `${height}px`};
  position: absolute;
  bottom: 0;
  left: 0;
  padding: ${({ fullSizeTile }) =>
    fullSizeTile ? '10px 1vw 0px 1vw' : '6px 1vw 0px 1vw'};
  &:hover {
    opacity: ${({ hideOnHover }) => hideOnHover && 0};
    z-index: ${({ hideOnHover }) => hideOnHover && -1};
  }
  ${({ hide }) => hide && 'display:none;'};
`;

const RibbonText = styled.p`
  color: ${({ ribbonTagColor }) =>
    Color(ribbonTagColor).isDark() ? '#fff' : '#000'};
  font-size: ${({ fullSizeTile }) => (fullSizeTile ? '1.1rem' : '0.7rem')};
  font-weight: 100;
  letter-spacing: 0.3px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const RibbonTagArrow = styled.div`
  width: 0;
  height: 0;
  border-left: ${({ height }) => `${height / 2}px solid transparent`};
  border-right: ${({ height }) => `${height / 2}px solid transparent`};
  position: absolute;
  right: ${({ height }) => `-${height / 2}px`};
  ${({ position, ribbonTagColor, height }) =>
    position === 'top'
      ? `border-bottom: ${height / 2}px solid ${ribbonTagColor}; bottom: 0;`
      : `border-top: ${height / 2}px solid ${ribbonTagColor}; top: 0;`}
`;
